import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { createClient } from 'graphql-ws';
var getAGGWebsocketURI = function getAGGWebsocketURI() {
  if (process.env.NODE_ENV !== 'production') {
    // In dev mode this allows the local dev proxy to use the WebSocket host
    // that matches the backend origin host. The __backendOriginHost is only
    // available with local dev server.
    var host = window.__backendOriginHost || window.location.host;
    return "wss://".concat(host, "/gateway/api/graphql/subscriptions");
  }
  return "wss://".concat(window.location.host, "/gateway/api/graphql/subscriptions");
};
var createAGGSubscriptionClient = function createAGGSubscriptionClient() {
  return createClient({
    url: getAGGWebsocketURI(),
    retryAttempts: 2,
    lazy: true
  });
};
var getAGGSubscriptionClient = function getAGGSubscriptionClient() {
  var client = window.__FORGE_AGG_SUBSCRIPTION_CLIENT__;
  if (!client) {
    client = createAGGSubscriptionClient();
    window.__FORGE_AGG_SUBSCRIPTION_CLIENT__ = client;
  }
  return client;
};
var BasicSubscription = /*#__PURE__*/function () {
  function BasicSubscription(baseUnsubscribe) {
    _classCallCheck(this, BasicSubscription);
    this.closed = false;
    this.baseUnsubscribe = baseUnsubscribe;
  }
  return _createClass(BasicSubscription, [{
    key: "unsubscribe",
    value: function unsubscribe() {
      if (!this.closed) {
        this.baseUnsubscribe();
        this.closed = true;
      }
    }
  }]);
}();
export var subscribe = function subscribe(payload, sink, client) {
  if (!client) {
    client = getAGGSubscriptionClient();
  }
  var unsubscribe = client.subscribe(payload, sink);
  return new BasicSubscription(unsubscribe);
};